import React from 'react';
import { useDeviceManager } from 'app/containers/rtc/DeviceManagerContext';
import CallModal from 'app/components/call/CallModal';
import { ButtonA } from 'app/components/presentation/buttons/ButtonClassNameA';
import { useI18n } from 'app/components/localization';

const PersistedScreenSharingRejectionModal: React.FC = () => {
  const deviceManager = useDeviceManager();
  const { t } = useI18n();

  const closeAndRetry = () => {
    deviceManager.dismissScreenSharingUserAction();
    deviceManager.toggleScreenSharing();
  };

  return (
    <CallModal
      title={t('rtc.screen-sharing.persisted-rejection-modal.title')}
      onClose={deviceManager.dismissScreenSharingUserAction}
      buttons={
        <ButtonA onClick={closeAndRetry}>
          {t('rtc.screen-sharing.persisted-rejection-modal.retry')}
        </ButtonA>
      }
    >
      <p>
        {t('rtc.screen-sharing.persisted-rejection-modal.body')}
      </p>
    </CallModal>
  );
};

export default PersistedScreenSharingRejectionModal;
